import { useState } from 'react'

function GuidePage() {
  const [activeTab, setActiveTab] = useState('buyer')

  return (
    <div className="min-h-screen bg-[#fefcf8]">
      <div className="w-full md:w-[90%] lg:w-[80%] mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#D4AF37] to-[#c09d2a] rounded-2xl p-8 md:p-12 mb-8 text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Mode d'Emploi</h1>
          <p className="text-lg">Guide complet pour utiliser KUDHI - Particuliers et Entreprises</p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-sm mb-6 overflow-hidden">
          <div className="flex border-b border-gray-200">
            <button
              onClick={() => setActiveTab('buyer')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors ${
                activeTab === 'buyer'
                  ? 'bg-[#D4AF37] text-white'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              👤 Pour les Acheteurs
            </button>
            <button
              onClick={() => setActiveTab('seller')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors ${
                activeTab === 'seller'
                  ? 'bg-[#D4AF37] text-white'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              💼 Pour les Vendeurs
            </button>
          </div>
        </div>

        {/* Contenu pour Acheteurs */}
        {activeTab === 'buyer' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-2xl font-bold text-[#001F3F] mb-6">Guide de l'Acheteur</h2>

              <div className="space-y-8">
                {/* Étape 1 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    1
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Créez votre compte</h3>
                    <p className="text-gray-700 mb-3">
                      Inscrivez-vous gratuitement en quelques clics. Vous aurez besoin de :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Votre nom complet</li>
                      <li>Un numéro de téléphone valide</li>
                      <li>Une adresse email</li>
                      <li>Un mot de passe sécurisé</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 2 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    2
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Recherchez des produits</h3>
                    <p className="text-gray-700 mb-3">
                      Utilisez la barre de recherche ou parcourez les catégories :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Filtrez par catégorie (Auto-Moto, Immobilier, Informatique, etc.)</li>
                      <li>Affinez par localisation pour trouver des annonces près de chez vous</li>
                      <li>Triez par prix, date de publication ou pertinence</li>
                      <li>Utilisez les filtres avancés pour une recherche précise</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 3 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    3
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Consultez les annonces</h3>
                    <p className="text-gray-700 mb-3">
                      Prenez le temps d'examiner chaque annonce :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Lisez attentivement la description du produit</li>
                      <li>Regardez toutes les photos disponibles</li>
                      <li>Vérifiez le prix et les conditions de livraison</li>
                      <li>Consultez le profil du vendeur et ses évaluations</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 4 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    4
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Contactez le vendeur</h3>
                    <p className="text-gray-700 mb-3">
                      Communiquez directement via notre messagerie :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Posez toutes vos questions sur le produit</li>
                      <li>Négociez le prix si possible</li>
                      <li>Convenez d'un lieu et d'une heure de rencontre</li>
                      <li>Demandez des photos supplémentaires si nécessaire</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 5 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    5
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Finalisez votre achat</h3>
                    <p className="text-gray-700 mb-3">
                      Sécurisez votre transaction :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Rencontrez le vendeur dans un lieu public</li>
                      <li>Inspectez le produit avant de payer</li>
                      <li>Testez le produit si possible</li>
                      <li>Ne payez jamais à l'avance sans garantie</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Conseils de sécurité */}
            <div className="bg-red-50 border border-red-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-red-900 mb-4 flex items-center gap-2">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                Conseils de Sécurité
              </h3>
              <ul className="text-red-900 space-y-2">
                <li>• Méfiez-vous des prix trop bas ou des offres trop alléchantes</li>
                <li>• Ne communiquez jamais vos informations bancaires par message</li>
                <li>• Privilégiez les rencontres en personne dans des lieux publics</li>
                <li>• Signalez toute annonce ou utilisateur suspect</li>
              </ul>
            </div>
          </div>
        )}

        {/* Contenu pour Vendeurs */}
        {activeTab === 'seller' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-2xl font-bold text-[#001F3F] mb-6">Guide du Vendeur</h2>

              <div className="space-y-8">
                {/* Étape 1 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    1
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Préparez votre annonce</h3>
                    <p className="text-gray-700 mb-3">
                      Avant de publier, assurez-vous d'avoir :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Des photos de qualité du produit (minimum 3)</li>
                      <li>Une description détaillée et honnête</li>
                      <li>Le prix exact ou négociable</li>
                      <li>Votre localisation précise</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 2 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    2
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Créez votre annonce</h3>
                    <p className="text-gray-700 mb-3">
                      Cliquez sur le bouton "+" et suivez ces étapes :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Choisissez le type d'annonce (Image, Vidéo, Bannière)</li>
                      <li>Sélectionnez la catégorie appropriée</li>
                      <li>Rédigez un titre accrocheur et clair</li>
                      <li>Ajoutez une description complète</li>
                      <li>Téléchargez vos meilleures photos</li>
                      <li>Définissez votre prix et les conditions de livraison</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 3 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    3
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Optimisez votre annonce</h3>
                    <p className="text-gray-700 mb-3">
                      Pour maximiser vos chances de vente :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Utilisez des mots-clés pertinents dans le titre</li>
                      <li>Prenez des photos lumineuses et nettes</li>
                      <li>Soyez honnête sur l'état du produit</li>
                      <li>Proposez plusieurs angles de vue</li>
                      <li>Indiquez si le prix est négociable</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 4 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    4
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Gérez vos messages</h3>
                    <p className="text-gray-700 mb-3">
                      Soyez réactif avec les acheteurs potentiels :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Répondez rapidement aux questions</li>
                      <li>Restez courtois et professionnel</li>
                      <li>Soyez flexible sur les horaires de rencontre</li>
                      <li>Acceptez les négociations raisonnables</li>
                    </ul>
                  </div>
                </div>

                {/* Étape 5 */}
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold">
                    5
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#001F3F] mb-3">Finalisez la vente</h3>
                    <p className="text-gray-700 mb-3">
                      Pour une transaction réussie :
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                      <li>Fixez un rendez-vous dans un lieu sûr</li>
                      <li>Apportez le produit en bon état</li>
                      <li>Vérifiez l'argent avant de remettre l'article</li>
                      <li>Marquez l'annonce comme vendue après la transaction</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Conseils pour réussir */}
            <div className="bg-green-50 border border-green-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-green-900 mb-4 flex items-center gap-2">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Conseils pour Réussir
              </h3>
              <ul className="text-green-900 space-y-2">
                <li>• Mettez régulièrement à jour vos annonces</li>
                <li>• Répondez dans les 24 heures aux messages</li>
                <li>• Proposez des prix compétitifs</li>
                <li>• Construisez une bonne réputation avec des transactions honnêtes</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default GuidePage
